import { useEffect, useRef, useState } from "react";
import {
    Button,
    Card,
    DatePicker,
    Form,
    Input,
    Select
} from "antd";
import { t } from "i18next";
import { useHistory, useParams } from "react-router-dom";
import SimpleLayout from "../../../core/components/layout/SimpleLayout";
import ApiService from "../../../core/service/ApiService";
import Helper from "../../../core/Helper";
import moment from "moment";
import { useLocation } from "react-router-dom";


export default function PatientBillingAddressCreateEdit() {

    const query = new URLSearchParams(useLocation().search);
    const billingAddressId = query.get("billingAddressId");
    const formRef = useRef();
    const history = useHistory();
    const [type, setType] = useState(1);
    const [billingAddress, setBillingAddress] = useState({});
    const { Option } = Select;

    const location = useLocation();
    const { patientName, patientLastname, patientCustomId, patientId } = location.state || {};
    const [districts, setDistrict] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);

    const getBillingAddress = async () => {
        if (billingAddressId) {
            const res = await ApiService.PatientBillingAddress.GetBillingAddress(billingAddressId);
            if (res.success) {
                formRef.current.setFieldsValue({
                    ...res.data
                });
                setBillingAddress(res.data)
                setType(res.data.type)

                if (res.data.cityId) {
                    await getDistricts(res.data.cityId);
                    setSelectedCity(res.data.cityId);
                }

                formRef.current.setFieldsValue({
                    ...res.data
                });
            }
        }
    }

    const getDistricts = async (cityId) => {
        const res = await ApiService.District.GetDistrictList(cityId);
        if (res.success) {
            setDistrict(res.data)
        } else {
            setDistrict([])
        }
    }

    const getCities = async () => {
        const res = await ApiService.City.GetCityList();
        if (res.success) {
            setCities(res.data)
        } else {
            setCities([])
        }
    }

    const onFinish = async (formData) => {
        if (billingAddressId) {
            const res = await ApiService.PatientBillingAddress.EditBillingAddress(billingAddressId, {
                ...formData,
                patientId: patientId
            }, formData);
            await getBillingAddress();
        }
        else {
            const res = await ApiService.PatientBillingAddress.CreateBillingAddress({
                ...formData,
                patientId: patientId
            });

            if (res.success) {
                history.push(`/app/system/billingAddress/edit/?billingAddressId=${res.data.id}`)
            }
        }
    }

    useEffect(() => {
        getBillingAddress()
    }, [billingAddressId])

    useEffect(() => {
        getCities()
    }, [])

    return (
        <SimpleLayout>
            <Card
                title={!billingAddressId ? t('New') : `${t('Edit')}`}
            >
                <Form
                    ref={formRef}
                    layout={'vertical'}
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="type"
                        label={t('Type')}
                        initialValues={{ type: 1 }}
                        rules={[{ required: true }]}
                    >
                        <Select
                            onChange={(val) => setType(val)}
                        >
                            <Option value={1}>Tüzel</Option>
                            <Option value={2}>Gerçek</Option>
                        </Select>
                    </Form.Item>

                    {type === 1 && (
                        <>
                            <Form.Item
                                name="companyName"
                                label={t('Company Name')}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="taxOffice"
                                label={t('Tax Office')}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="taxNumber"
                                label={t('Tax Number')}
                            >
                                <Input />
                            </Form.Item>
                        </>
                    )}

                    {type === 2 && (
                        <>
                            <Form.Item
                                name="name"
                                label={t('Name')}
                                initialValue={patientName}
                            >
                                <Input disabled />
                            </Form.Item>
                            <Form.Item
                                name="surname"
                                label={t('Surname')}
                                initialValue={patientLastname}
                            >
                                <Input disabled />
                            </Form.Item>
                            <Form.Item
                                name="taxnumber"
                                label={t('Tax Number')}
                                initialValue={patientCustomId}
                            >
                                <Input disabled />
                            </Form.Item>
                        </>
                    )}
                    <Form.Item
                        name="phoneNumber"
                        label={t('Phone Number')}
                    >
                        <Input />
                    </Form.Item>


                    <Form.Item
                        name="email"
                        label={t('Email')}
                        rules={[
                            {
                                type: 'email',
                                message: t('Lütfen geçerli bir e-posta adresi giriniz'),
                            },
                        ]}

                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="cityId"
                        label={t('City')}
                        rules={[{ required: true }]}
                    >
                        <Select
                            showSearch
                            allowClear
                            placeholder="Select a city"
                            options={cities.map(c => ({ value: c.id, label: c.name }))}
                            filterOption={(input, option) =>
                                option.label.toLowerCase().includes(input.toLowerCase())
                            }
                            onChange={(val) => {
                                setSelectedCity(val);
                                getDistricts(val);
                                formRef.current.setFieldsValue({ districtId: undefined });
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="districtId"
                        label={t('District')}
                        rules={[{ required: true }]}
                    >
                        <Select
                            showSearch
                            allowClear
                            placeholder="Select a district"
                            options={districts.map(c => ({ value: c.id, label: c.name }))}
                            filterOption={(input, option) =>
                                option.label.toLowerCase().includes(input.toLowerCase())
                            }
                            disabled={!selectedCity}
                        />
                    </Form.Item>

                    <Form.Item
                        name="fullAddress"
                        label={t('Full Address')}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="billingAddressName"
                        label={t('Billing Address Name')}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item>
                        <Button htmlType={'submit'} type={'primary'}>{t('Save')}</Button>
                    </Form.Item>
                </Form>
            </Card>
        </SimpleLayout>
    )
}